module.exports = __webpack_public_path__ + "img/solution15.78144662.png";